// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1vUoJ","inner":"Footer_inner__1mU0i","nextIcon":"Footer_nextIcon__1Ewqe","innerLeft":"Footer_innerLeft__1-z9g"};